import { Route, Routes, Navigate} from 'react-router-dom';

import { Login } from './Login';
import { ForgotPassword } from './ForgotPassword';
import { ResetPassword } from './ResetPassword';
import { ActivateUser } from './ActivateUser';

export const AuthRoutes = () => {
  return (
    <Routes>
        <Route path="login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password/:user_uuid/:token" element={<ResetPassword />} />
        <Route path="activate/:user_uuid/:token" element={<ActivateUser />} />
        <Route index path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};
